export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImgViewZoom.vue?vue&type=template&id=b15fd554&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ImgViewZoom.vue?vue&type=template&id=b15fd554&scoped=true&
// module id = 771
// module chunks = 0